import React from 'react';

import Text from 'components/core/Text';

import { StyledDescription, StyledEmptyState } from './EmptyState.styles';
import { TEmptyStateProps } from './EmptyState.types';

const EmptyState = ({ title, description, action }: TEmptyStateProps) => (
  <StyledEmptyState>
    <Text variant="subtitle" color="textSecondary">
      {title}
    </Text>
    {description ? (
      <StyledDescription>
        <Text variant="body" color="textMuted">
          {description}
        </Text>
      </StyledDescription>
    ) : null}
    {action}
  </StyledEmptyState>
);

export default EmptyState;
